module.exports = __webpack_public_path__ + "static/media/2.3c70e5d2.svg";